<template>
  <div>
    <v-card flat class="ma-5">
      <v-card-title primary-title>
        <h2>สิทธิ์การใช้งาน</h2>
        <v-spacer></v-spacer>
        <v-btn class="bg_btn_gradient" dark @click="addPermission()">
          <v-icon left>mdi-plus-circle</v-icon>
          <span class="text_body_6">เพิ่มสิทธิ์</span>
        </v-btn>
      </v-card-title>

      <!-- <pre>{{permissionList}}</pre> -->
      <v-card-text class="px-0">
        <v-list-item v-for="item in permissionList" :key="item.permission_id">
          <v-list-item-avatar>
            <v-icon large>mdi-account-circle</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="item.permissionName"></v-list-item-title>
          </v-list-item-content>

          <v-list-item-icon>
            <v-btn icon :disabled="item.permissionStatus == 'lock'" @click="editPermission(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon :disabled="item.permissionStatus == 'lock'" @click="deletePermission(item)">
              <v-icon small color="#ff5252">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-icon>
        </v-list-item>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="permission_dialog"
      scrollable
      persistent
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title style="background-color: #0c57d2; color: #ffffff">
          <v-row justify="center" align="center">
            <v-col cols="12" justify="center" align="center">
              <h3>ตั้งค่าสิทธิ์</h3>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="py-0">
              <v-form ref="form">
                <v-text-field
                  name="Role Name"
                  label="ชื่อสิทธิ์"
                  v-model="permissionName"
                  dark
                  outlined
                  dense
                  :rules="rule_empty"
                ></v-text-field>
              </v-form>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <!-- Module BackOffice -->
          <v-row align="center">
            <v-col cols="12">
              <font class="text_title_3 mx-5">ระบบหลังบ้าน</font>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-row justify="start" align="center" class="text_title_3">
                <v-col cols="12" sm="4" md="3" class="py-0">
                  <v-checkbox label="แดชบอร์ด (ค่าเริ่มต้น)" v-model="dashboard_default"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="py-0">
                  <v-checkbox
                    label="สร้าง / แก้ไข คำทับศัพท์"
                    v-model="moduleBackOffice"
                    value="create_edit_word"
                    :disabled="!dashboard_default"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="py-0">
                  <v-checkbox
                    label="ประวัติการค้นหาคำศัพท์"
                    v-model="moduleBackOffice"
                    value="history"
                    :disabled="!dashboard_default"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="py-0">
                  <v-checkbox
                    label="ประวัติคำที่ค้นหาไม่พบ"
                    v-model="moduleBackOffice"
                    value="unknown_word"
                    :disabled="!dashboard_default"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="py-0">
                  <v-checkbox
                    label="แบบประเมินความพึงพอใจ"
                    v-model="moduleBackOffice"
                    value="satisfaction"
                    :disabled="!dashboard_default"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="py-0">
                  <v-checkbox
                    label="คำที่เสนอ / การแจ้งเตือน"
                    v-model="moduleBackOffice"
                    value="request_word_and_notification"
                    :disabled="!dashboard_default"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <!-- Module Setting -->
            <v-col cols="12">
              <font class="text_title_3 mx-5">การตั้งค่าระบบ</font>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-row justify="start" align="center" class="text_title_3">
                <v-col cols="12" sm="4" md="3" class="py-0">
                  <v-checkbox label="ภาษา" v-model="moduleSetting" value="language"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="py-0">
                  <v-checkbox label="หมวดหมู่" v-model="moduleSetting" value="category"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="py-0">
                  <v-checkbox label="สิทธ์การใช้งาน" v-model="moduleSetting" value="permission"></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" class="text_title_1" text @click="permission_dialog = false">ยกเลิก</v-btn>
          <v-btn color="primary " class="text_title_1" @click="savePermissionData()">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import * as rules from "@/assets/javascript/rules.js";
export default {
  data() {
    return {
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      // dialog
      permission_dialog: false,
      permission_index: "",

      // all permission
      permissionList: [],
      permissionId: "",

      // selector module
      permissionName: "",
      dashboard_default: false,
      moduleBackOffice: [],
      moduleSetting: [],

      // rules
      rule_empty: rules.isEmptyTextField,
    };
  },

  computed: {},

  watch: {
    dashboard_default(value) {
      if (value == false) {
        this.moduleBackOffice = [];
      } else {
        if (!this.moduleBackOffice.includes("dashboard")) {
          this.moduleBackOffice.push("dashboard");
        }
      }
    },
  },
  created() {
    this.getPermissionList();
  },
  methods: {
    getPermissionList() {
      this.axios
        .get(process.env.VUE_APP_API + "api/v1/permission", this.header_token)
        .then((response) => {
          // console.log(response.data);
          if (response.data) {
            this.permissionList = response.data;
          } else {
            this.permissionList = [];
          }
        })
        .catch((err) => {
          // console.log("get permission err");
          this.permissionList = [];
        });
    },
    addPermission() {
      this.permission_dialog_mode = "create";
      this.permission_dialog = true;
      setTimeout(() => {
        this.dashboard_default = false;
        this.moduleBackOffice = [];
        this.moduleSetting = [];
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }, 100);
    },
    editPermission(item) {
      this.permission_dialog_mode = "edit";
      this.permission_index = item.permissionId;
      // set variable
      if (item.backOffice.length > 0) {
        if (item.backOffice.includes("dashboard")) {
          this.dashboard_default = true;
          this.moduleBackOffice = item.backOffice;
        }
      }
      this.permissionName = item.permissionName ? item.permissionName : "";
      // this.moduleBackOffice = item.backOffice ? item.backOffice : [];
      this.moduleSetting = item.setting ? item.setting : [];
      this.permission_dialog = true;
    },
    savePermissionData() {
      if (this.$refs.form.validate()) {
        let data = {
          permissionName: this.permissionName,
          permissionModule: {
            backOffice: this.moduleBackOffice,
            setting: this.moduleSetting,
          },
        };
        // console.log(data);
        if (this.permission_dialog_mode == "create") {
          // console.log("created");
          this.axios
            .post(
              process.env.VUE_APP_API + "api/v1/permission",
              data,
              this.header_token
            )
            .then((response) => {
              // console.log(response.data);
              if (response.data == "success") {
                this.$swal.fire({
                  icon: "success",
                  title: "สร้างสิทธิ์การใช้งานใหม่สำเร็จ",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.permission_dialog = false;
                this.getPermissionList();
              } else if (response.data == "name already") {
                this.permissionName = "";
                this.$swal.fire({
                  icon: "warning",
                  title: "ช้อมูลซ้ำ",
                  text: "ชื่อสิทธิ์นี้ถูกใช้ไปแล้ว",
                  showConfirmButton: false,
                  timer: 1000,
                });
              }
            })
            .catch((err) => {
              // console.log("api post err");
            });
        } else if (this.permission_dialog_mode == "edit") {
          // console.log("edited");
          this.axios
            .put(
              process.env.VUE_APP_API +
                "api/v1/permission/" +
                this.permission_index,
              data,
              this.header_token
            )
            .then((response) => {
              // console.log(response.data);
              if (response.data == "update success") {
                this.$swal.fire({
                  icon: "success",
                  title: "แก้ไขสิทธิ์การใช้งานสำเร็จ",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.permission_dialog = false;
                this.getPermissionList();
              } else if (response.data == "name already") {
                this.permissionName = "";
                this.$swal.fire({
                  icon: "warning",
                  title: "ช้อมูลซ้ำ",
                  text: "ชื่อสิทธิ์นี้ถูกใช้ไปแล้ว",
                  showConfirmButton: false,
                  timer: 1000,
                });
              }
            })
            .catch((err) => {
              // console.log("api post err");
            });
        }
      }
    },
    deletePermission(item) {
      this.$swal
        .fire({
          title: "คุณต้องการลบข้อมูลสิทธิ์การใช้งานนี้ใช่หรือไม่?",
          text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          // cancelButtonColor: "#3085d6",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((result) => {
          if (result.value) {
            this.axios
              .delete(
                process.env.VUE_APP_API +
                  "api/v1/permission/" +
                  item.permissionId,
                this.header_token
              )
              .then((response) => {
                // console.log(response.data);
                if (response.data == "delete success") {
                  this.$swal.fire({
                    icon: "success",
                    title: "ลบข้อมูลข้อมูลสิทธิ์การใช้งานสำเร็จ",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  this.getPermissionList();
                }
              })
              .catch((err) => {
                // console.log("api delete err");
              });
          }
        });
    },
  },
};
</script>
